var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6778 53.9893C61.6778 58.3908 58.1116 61.9592 53.71 61.9592H13.861C9.46087 61.9592 5.89209 58.3908 5.89209 53.9893V14.1421C5.89209 9.74073 9.46087 6.17352 13.861 6.17352H53.71C58.1116 6.17352 61.6778 9.74073 61.6778 14.1421V53.9893Z",
    fill: "#FFE400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4041 41.1387H31.7979V26.7769H34.375C34.375 26.7769 34.3643 26.7705 34.3745 26.7704C34.3746 26.7726 34.3749 26.7748 34.375 26.7769H34.4041V41.1387ZM45.5033 40.0565C45.202 37.8786 44.1968 36.0417 42.5166 34.5956C42.2683 34.3819 42.0085 34.1817 41.716 33.9443C41.9575 33.7625 42.161 33.6227 42.3498 33.4653C43.5492 32.4666 44.4324 31.2453 45.0098 29.7895C45.5585 28.4061 45.6962 26.9709 45.5001 25.5256C45.2593 23.753 44.5108 22.1837 43.2875 20.8552C42.406 19.898 41.3783 19.1425 40.1734 18.6512C39.013 18.1781 37.8226 17.9638 36.5399 17.9638L22.5945 17.9664C22.4981 17.9664 22.4007 17.9616 22.3052 17.9724C21.9634 18.0111 21.7622 18.2284 21.7469 18.5714C21.7425 18.6676 21.7464 18.7643 21.7464 18.8606C21.7464 28.8912 21.7463 38.9217 21.7464 48.9521C21.7464 49.1038 21.738 49.256 21.7493 49.4068C21.7691 49.6713 21.9502 49.867 22.2121 49.9103C22.3064 49.926 22.4046 49.921 22.5011 49.921L36.9431 49.9212C38.4261 49.9222 39.8118 49.5488 41.0899 48.815C42.9214 47.7632 44.2293 46.2553 45.0094 44.2787C45.5507 42.9067 45.7013 41.4865 45.5033 40.0565Z",
    fill: "#1E1719"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_30",
    x: -3.74292,
    y: 0.542847,
    width: 74.9429,
    height: 74.9429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_30",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/카카오뱅크.5820a0fdc734476ed7845d32baebf5c6.svg";
export { ForwardRef as ReactComponent };